import script from "./DropdownMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownMobile.vue?vue&type=script&setup=true&lang=js"

import "./DropdownMobile.vue?vue&type=style&index=0&id=038a072a&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038a072a"]])

export default __exports__